export default __webpack_public_path__ + "static/media/tap.e85cc3fb.wav";